import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

/*const modulesContext = require.context('./modules/', true, /\.module\.ts$/i);

const schCommonsStoreModules = modulesContext.keys().reduce((accumulator, moduleName) => {
    return {...accumulator, [moduleName.split('.')[1].substr(1)]: modulesContext(moduleName).default};
}, {});

export default schCommonsStoreModules;*/

export default {};
